import React from "react";
import { Instagram, LogIn } from "lucide-react";
import { useLang, RESERVE_URL } from "../context/LanguageContext";

const LOGO_FULL = "https://customer-assets.emergentagent.com/job_261f6229-25c6-462a-bf7c-d1c15ef074eb/artifacts/vpvrvwp5_logo%20imagotip%20xpro%20blanco.png";

export default function Footer() {
  const { t } = useLang();

  return (
    <footer data-testid="site-footer" className="relative bg-black border-t border-white/10">
      {/* CTA band */}
      <div className="border-b border-white/10 py-16 md:py-24">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 flex flex-col md:flex-row items-start md:items-center justify-between gap-8">
          <h3 className="font-display text-4xl md:text-6xl text-white leading-[0.95] max-w-3xl">
            {t.hero.headline1} {t.hero.headline2} <span className="text-[#FFCC00]">{t.hero.headline3}</span>
          </h3>
          <a
            href={RESERVE_URL}
            target="_blank"
            rel="noopener noreferrer"
            data-testid="footer-cta"
            className="inline-flex items-center gap-3 px-8 py-5 bg-[#FFCC00] text-black font-bold text-xs tracking-[0.25em] uppercase hover:bg-white transition-colors shrink-0"
          >
            {t.nav.cta}
            <span className="inline-block w-6 h-px bg-current" />
          </a>
        </div>
      </div>

      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16 grid md:grid-cols-12 gap-10">
        <div className="md:col-span-5">
          <img src={LOGO_FULL} alt="XPRO Fitness" className="h-12 w-auto mb-6" />
          <p className="text-white/60 font-body max-w-sm">
            {t.footer.tagline}
          </p>
        </div>

        <div className="md:col-span-3">
          <div className="text-[11px] tracking-[0.3em] uppercase font-bold text-[#FFCC00] mb-6">
            {t.footer.links}
          </div>
          <ul className="space-y-3">
            <li><a href="#facilities" className="text-white/70 hover:text-[#FFCC00]">{t.nav.facilities}</a></li>
            <li><a href="#services" className="text-white/70 hover:text-[#FFCC00]">{t.nav.services}</a></li>
            <li><a href="#schedule" className="text-white/70 hover:text-[#FFCC00]">{t.nav.schedule}</a></li>
            <li><a href="#pricing" className="text-white/70 hover:text-[#FFCC00]">{t.nav.pricing}</a></li>
            <li><a href="#location" className="text-white/70 hover:text-[#FFCC00]">{t.nav.contact}</a></li>
            <li className="pt-2 border-t border-white/10">
              <a
                href="/login"
                data-testid="footer-acceso-socios"
                className="inline-flex items-center gap-2 text-[#FFCC00] hover:text-white font-bold transition-colors"
              >
                <LogIn size={13} />
                Acceso Socios
              </a>
            </li>
          </ul>
        </div>

        <div className="md:col-span-2 md:col-start-11">
          <div className="text-[11px] tracking-[0.3em] uppercase font-bold text-[#FFCC00] mb-6">
            {t.footer.follow}
          </div>
          <div className="flex gap-3">
            <a
              href="https://www.instagram.com/xprofitness_/"
              target="_blank"
              rel="noopener noreferrer"
              aria-label="Instagram"
              className="w-11 h-11 border border-white/15 flex items-center justify-center text-white hover:border-[#FFCC00] hover:text-[#FFCC00] transition-colors"
              data-testid="social-ig"
            >
              <Instagram size={16} />
            </a>
          </div>
        </div>
      </div>

      <div className="border-t border-white/10">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-6 flex flex-col md:flex-row items-start md:items-center justify-between gap-4 text-xs text-white/40 tracking-wider">
          <div>© 2026 XPRO FITNESS · {t.footer.rights}</div>
          <div className="flex flex-wrap items-center gap-x-4 gap-y-2">
            <a href="/legal/aviso-legal" data-testid="footer-legal-aviso" className="hover:text-[#FFCC00] uppercase tracking-[0.18em] text-[10px]">Avís legal</a>
            <span className="w-1 h-1 bg-white/20" />
            <a href="/legal/privacidad" data-testid="footer-legal-privacy" className="hover:text-[#FFCC00] uppercase tracking-[0.18em] text-[10px]">Privacitat</a>
            <span className="w-1 h-1 bg-white/20" />
            <a href="/legal/cookies" data-testid="footer-legal-cookies" className="hover:text-[#FFCC00] uppercase tracking-[0.18em] text-[10px]">Cookies</a>
            <span className="w-1 h-1 bg-white/20" />
            <a href="/legal/condiciones" data-testid="footer-legal-terms" className="hover:text-[#FFCC00] uppercase tracking-[0.18em] text-[10px]">Condicions</a>
            <span className="w-1 h-1 bg-white/20" />
            <a href="/login" data-testid="footer-acceso-socios-bottom" className="inline-flex items-center gap-1.5 text-[#FFCC00]/70 hover:text-[#FFCC00] uppercase tracking-[0.18em] text-[10px] transition-colors">
              <LogIn size={10} /> Acceso Socios
            </a>
          </div>
          <div className="flex items-center gap-3">
            <span className="w-1.5 h-1.5 bg-[#FFCC00] rotate-45" />
            <span className="uppercase tracking-[0.2em]">Vidreres · Girona</span>
          </div>
        </div>
      </div>
    </footer>
  );
}
